/**
 * Unchecked items only exist on the transaction thus don't have a product associated with them
 *
 * @format
 */
import { ProductItemSummary } from '@toucan/client/global/transaction';

import { UNCHECKED_PRODUCT_ID } from '../config/constants';

export const isUncheckedItem = ({ productId }: ProductItemSummary) =>
    productId === UNCHECKED_PRODUCT_ID;
